export default __webpack_public_path__ + "static/media/tool2.73866c40.png";